// Script pour mettre à jour la bannière promo dans collections-auto
// Récupère les promos actives et met à jour le bloc bleu
// V2: Utilise l'endpoint collection-spécifique si on est sur une page collection

(function() {
  console.log('🎁 Banner Promo Updater V2 - Chargement...');

  const API_BASE = 'https://trust-logistics.vercel.app/api/discounts';
  
  // Détecter le handle de la collection depuis l'URL (/collections/xxx)
  function getCollectionHandle() {
    const match = window.location.pathname.match(/^\/collections\/([^\/\?#]+)/);
    return match ? match[1] : null;
  }
  
  async function updatePromoBanner() {
    try {
      // Trouver la bannière promo
      const banner = document.querySelector('.card-image-promo-banner');
      if (!banner) {
        console.log('⚠️  Bannière promo non trouvée');
        return;
      }

      console.log('🔍 Bannière promo détectée, récupération des promotions...');

      // Si on est sur une page collection, utiliser l'endpoint spécifique
      const collectionHandle = banner.dataset.collectionHandle || getCollectionHandle();
      let promo = null;
      
      if (collectionHandle) {
        console.log('🔍 Collection détectée:', collectionHandle);
        const collRes = await fetch(API_BASE + '/collection?handle=' + encodeURIComponent(collectionHandle));
        const collData = await collRes.json();
        if (collData.success && collData.bestDiscount) {
          promo = collData.bestDiscount;
        }
      }
      
      // Fallback: endpoint global (newsletter déjà filtrées côté API)
      if (!promo) {
        const response = await fetch(API_BASE);
        const data = await response.json();
        if (!data.success || !data.discounts || data.discounts.length === 0) {
          console.log('❌ Aucune promotion disponible');
          return;
        }
        const activePromos = data.discounts.filter(d => d.status === 'ACTIVE');
        if (activePromos.length === 0) {
          console.log('⚠️  Aucune promotion active');
          return;
        }
        // Trier par valeur décroissante pour la meilleure promo
        promo = activePromos.sort((a, b) => (b.valueRaw || 0) - (a.valueRaw || 0))[0];
      }
      
      if (!promo) {
        console.log('⚠️  Aucune promotion trouvée');
        return;
      }
      
      console.log('🎁 Promotion trouvée:', promo.title || promo.originalTitle);

      // Mettre à jour le contenu
      const heading = banner.querySelector('.card-image__heading, h2, .h2');
      const subheading = banner.querySelector('.card-image__subheading');
      const description = banner.querySelector('.card-image__description, p');
      const button = banner.querySelector('.btn, a');

      if (heading) {
        heading.textContent = promo.title || promo.originalTitle || 'Offre spéciale';
      }

      if (subheading) {
        subheading.textContent = promo.valueLabel || promo.value || '';
      }

      if (description) {
        let desc = '';
        if (promo.type === 'DiscountCodeBasic') {
          desc = `Réduction de ${promo.value}`;
          if (promo.endsAt) {
            const endDate = new Date(promo.endsAt);
            desc += ` • Expire le ${endDate.toLocaleDateString()}`;
          }
        } else {
          desc = 'Promotion automatique appliquée au panier';
        }
        description.textContent = desc;
      }

      if (button) {
        if (promo.code) {
          button.textContent = `Code: ${promo.code}`;
        } else {
          button.textContent = 'Voir les produits';
        }
      }

      console.log('✅ Bannière promo mise à jour!');

    } catch (error) {
      console.error('❌ Erreur mise à jour bannière:', error);
    }
  }

  // Lancer la mise à jour après chargement du DOM
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updatePromoBanner);
  } else {
    updatePromoBanner();
  }

  // Re-lancer lors du changement d'onglet (si tabs)
  document.addEventListener('click', function(e) {
    if (e.target.closest('.tabs__btn')) {
      setTimeout(updatePromoBanner, 100);
    }
  });

})();
